import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/fitguide/components/FitGuideClient.tsx");
